import { From, MessageAuth, MessageInterface, MessageType } from "@swivl-mono/types";
import React from "react";

import { SwivlChat } from "../../SwivlChat";
import { MessageHandlerInterface } from "../../messages/MessageHandler";
import "./ListItem.scss";
import { Buttons } from "./types/Buttons/Buttons";
import { Carousel } from "./types/Carousel/Carousel";
import { LocationPicker } from "./types/LocationPicker/LocationPicker";
import { Media } from "./types/Media/Media";
import { MultiSelect } from "./types/MultiSelect/MultiSelect";
import { ProfileCollect } from "./types/ProfileCollect/ProfileCollect";
import { SpacePicker } from "./types/SpacePicker/SpacePicker";
import { TakeoverEvent } from "./types/TakeoverEvent/TakeoverEvent";
import { Text } from "./types/Text/Text";

export interface ListItemProps {
  auth?: MessageAuth;
  item: ListItemData;
  messageHandler: MessageHandlerInterface;
  width: number;
  height: number;
  delegate: SwivlChat;
}
export interface ListItemState {
  // expand:boolean;
  contentHeight: number;
  contentWidth: number;
  // [id:string]:any;
  // items:Array<ListItemItemInterface>;
}

export interface ListItemData {
  id: string;
  message: MessageInterface;
  sender: From;
  hasTyping: boolean;
  isHTML: boolean;
  /** Active indicates if it is the most recent and active item in a list. If an item is not active, buttons can't be clicked etc. */
  isActive: boolean;
}

interface ListItemInterface {}

export class ListItem extends React.Component<ListItemProps> implements ListItemInterface {
  constructor(props: ListItemProps) {
    super(props);
    // var messages: { [id: string] : Message; } = {};

    // this.props.delegate.ListItem = this;
    // this.onClick        = this.onClick.bind(this);
    // this.onSize         = this.onSize.bind(this);
    this.isLeft = this.isLeft.bind(this);
    this.contentForItem = this.contentForItem.bind(this);
  }
  componentWillMount() {}
  // onClick() {
  //   this.setState({expand:!this.state.expand});
  // }
  // onSize(size:any):void {

  //   const contentWidth = (size && size.width) ? size.width : 0;
  //   const contentHeight = (size && size.height) ? size.height : 0;
  //   this.setState({contentHeight:contentHeight, contentWidth:contentWidth});
  // }

  isLeft(sender: From): boolean {
    if (!this.props.auth || this.props.auth.from === From.USER) {
      return sender === From.USER ? false : true;
    } else {
      return sender === From.USER ? true : false;
    }
  }

  contentForItem(item: any, isLeft: boolean) {
    const type = item.message?.type;

    switch (type) {
      case MessageType.Text:
        return <Text isLeft={isLeft} item={item} />;
        break;
      case MessageType.Buttons:
        // if (item.isActive) {
        return <Buttons item={item} messageHandler={this.props.messageHandler} />;
        // } else {
        //   return null;
        // }
        break;
      case MessageType.LocationPicker:
        return <LocationPicker item={item} isActive={item.isActive} messageHandler={this.props.messageHandler} width={this.props.width} />;
      case MessageType.SpacePicker:
        return (
          <SpacePicker
            item={item}
            isActive={item.isActive}
            messageHandler={this.props.messageHandler}
            width={this.props.width}
            height={this.props.height}
            delegate={this.props.delegate}
          />
        );
      case MessageType.ProfileCollect:
        return <ProfileCollect item={item} messageHandler={this.props.messageHandler} isActive={item.isActive} />;
        break;
      case MessageType.Carousel:
        return <Carousel item={item} isActive={item.isActive} messageHandler={this.props.messageHandler} width={this.props.width} />;
        break;
      case MessageType.TakeoverEvent:
        return <TakeoverEvent item={item as any} />;
        break;
      case MessageType.MultiSelect:
        return <MultiSelect item={item} messageHandler={this.props.messageHandler} />;
        break;
      case MessageType.Media:
        return <Media item={item} width={this.props.width} />;
        break;
      case MessageType.Typing:
        return null;
      case MessageType.StartConversation:
        return null;
      default:
        console.warn("swivl-unknown type", type);
        return null;
        // return <Invisible item={item} />;
        break;
    }
  }

  render() {
    const isLeft = this.isLeft(this.props.item.sender);
    const sideClass = isLeft ? "scc-left" : "scc-right";

    // if (!this.props.item.isActive && (
    //     this.props.item.message.type === MessageType.Typing ||
    //     (this.props.item.message.type === MessageType.Buttons && !this.props.item.message.actionTaken)
    //   )) { return null; }

    const item = this.props.item as any;

    // const height = (this.state.contentHeight) ? this.state.contentHeight : 30;

    if (item.message?.payload?.text && item.message?.type === MessageType.Buttons) {
      const buttons = this.contentForItem(item, isLeft);
      return (
        <>
          <div className={"scc-ListItem " + sideClass}>
            <div className="scc-Buttons">{buttons}</div>
          </div>
          <div className={"scc-ListItem " + sideClass}>
            <Text isLeft={isLeft} item={item} />
          </div>
        </>
      );
    }

    const data = this.contentForItem(item, isLeft); //

    if (!data) {
      return null;
    } else {
    }

    return (
      <div
        className={"scc-ListItem " + sideClass}
        // style={{height:height + "px"}}
        // onClick={this.onClick}
      >
        {data}
      </div>
    );
  }

  renderHasTyping() {}
}
